export default "__VITE_ASSET__9IgTpq7v__"